import { render } from "./CollapsibleTags.vue?vue&type=template&id=b3c00930&scoped=true"
import script from "./CollapsibleTags.vue?vue&type=script&lang=js"
export * from "./CollapsibleTags.vue?vue&type=script&lang=js"

import "./CollapsibleTags.vue?vue&type=style&index=0&id=b3c00930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c00930"]])

export default __exports__